import axios from "axios";
import { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

const RegistrarObligaciones = () => {
  const { id } = useParams(); // ID del contrato
  const navigate = useNavigate();

  const [observacion, setObservacion] = useState("");
  const [loading, setLoading] = useState(false);

  const hasContrato = useMemo(() => Boolean(id), [id]);

  const cleanData = () => {
    setObservacion("");
  };

  const saveObligaciones = async (e) => {
    e.preventDefault();

    if (!hasContrato) {
      return Swal.fire({
        icon: "error",
        title: "Falta el contrato",
        text: "No se recibió el ID del contrato en la URL.",
      });
    }

    try {
      setLoading(true);

      const response = await axios.post("/api/obligaciones/add", {
        contratoObjectId: id,
        observacion,
      });

      if (response.data.ok) {
        await Swal.fire({
          icon: "success",
          title: "Obligación registrada correctamente",
          showConfirmButton: false,
          timer: 1500,
        });

        cleanData();
      } else {
        Swal.fire({
          icon: "error",
          title: "No se pudo registrar",
          text: response.data.message || "Error inesperado",
        });
      }
    } catch (error) {
      console.error("Error al registrar la obligación:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "No se pudo guardar la obligación",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-body-tertiary py-4">
      <div className="container-fluid px-2 px-md-4">
        <div className="bg-white border rounded-4 shadow-sm overflow-hidden">
          {/* Header */}
          <div className="px-3 px-md-4 py-3 border-bottom bg-white">
            <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
              <div>
                <h5 className="mt-2 mb-1 fw-semibold">Registrar Obligación Contractual</h5>
                <small className="text-secondary">
                  Registra una actividad u obligación asociada al contrato.
                </small>
              </div>

              <div className="d-flex gap-2 flex-wrap">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => navigate(-1)}
                  disabled={loading}
                  title="Volver"
                >
                  <i className="fa-solid fa-arrow-rotate-left me-2"></i>

                  Volver
                </button>

                <button
                  type="button"
                  className="btn btn-outline-dark"
                  onClick={cleanData}
                  disabled={loading}
                  title="Limpiar"
                >
                  <i className="fa-solid fa-eraser me-2"></i>
                  Limpiar
                </button>
              </div>
            </div>
          </div>

          {/* Body */}
          <div className="p-3 p-md-4">
            {loading && (
              <div className="text-center text-secondary py-3">
                <div className="spinner-border" role="status" />
                <div className="mt-2">Procesando…</div>
              </div>
            )}

            <form id="form-obligacion" onSubmit={saveObligaciones} className="needs-validation" noValidate>
              <div className="row g-3">
                {/* Observación */}
                <div className="col-12">
                  <label className="form-label fw-semibold">Actividad u Obligación</label>
                  <textarea
                    className="form-control"
                    rows="6"  // ✅ más renglones
                    value={observacion}
                    onChange={(e) => setObservacion(e.target.value)}
                    placeholder="Describa la actividad u obligación a realizadar..."
                    required
                    disabled={loading}
                  />
                  <div className="form-text">
                    Recomendación: escribe información clara (qué se hizo, cuándo y resultado).
                  </div>
                </div>

                {/* Footer botones */}
                <div className="col-12 pt-2">
                  <div className="d-flex flex-wrap gap-2 justify-content-end">
                    <button
                      type="button"
                      className="btn btn-outline-danger"
                      onClick={() => navigate(-1)}
                      disabled={loading}
                      title="Cancelar"
                    >
                      <i className="fa-solid fa-xmark me-2"></i>
                      Cancelar
                    </button>

                    <button
                      type="submit"
                      form="form-obligacion"
                      className="btn btn-dark"
                      disabled={loading}
                      title="Registrar"
                    >
                      <i className={`fa-solid ${loading ? "fa-spinner fa-spin" : "fa-floppy-disk"} me-2`}></i>
                      Registrar Actividad
                    </button>
                  </div>
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrarObligaciones;
